import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import Modal from "@acadia-ui/modal";
import GCMPushModal from "../../Modals/GCMPushModal";
import { useCallback, useEffect, useMemo, useRef } from "react";

export default function useGCMSync({ selectedRows, gcmEnabled, refresh, metaData, dataTableApi }) {
	const Trigger = useCallback(() => {
		const selectedIds =
			dataTableApi?.current?.rowSelectionManager?.tree?.children?.loadedNodes
				?.filter(({ selectionState }) => selectionState === true)
				?.map(({ renderProps }) => renderProps.value) || [];
		const selectedRows = selectedIds?.map((id) => dataTableApi?.current?.dataProvider?.data?.find?.(({ UniqueID }) => UniqueID === id)) || [];
		const hasGCMSyncID = JSON.parse(metaData?.PlatformCampaignPK || "[]")?.find(({ MasterPlatformID }) => MasterPlatformID == 1)?.PlatformPK?.length > 0 || false;
		const triggerDisabled = !hasGCMSyncID || selectedRows?.some((row) => row.ExternalSystemStatusID == "3" || row.IsDraft === "True");

		if (gcmEnabled) {
			const title = !hasGCMSyncID ? "Please sync your campaign first" : "Sync";
			return (
				<Tooltip key="action-sync" title={title} position={TOOLTIP_POSITION.BOTTOM_START}>
					<Button
						size={BUTTON_SIZE.SMALL}
						display={BUTTON_DISPLAY.ICON_BORDERED}
						icon="icon-status-syncing"
						onClick={() => Modal.show("GCM_placement_modal")}
						disabled={triggerDisabled}
						data-tracking-id-alt="open-gcm-sync-modal"
					>
						Sync
					</Button>
				</Tooltip>
			);
		}
		return <></>;
	}, [gcmEnabled, metaData]);

	const DisplayedComponent = useCallback(() => {
		return <GCMPushModal modalId="GCM_placement_modal" type={"Placement"} data={selectedRows} refresh={refresh} />;
	}, [selectedRows, refresh]);

	return useMemo(() => [Trigger, DisplayedComponent], [Trigger, DisplayedComponent]);
}
